import { render, staticRenderFns } from "./versionInformation.vue?vue&type=template&id=7a9bd08a&scoped=true&"
import script from "./versionInformation.vue?vue&type=script&lang=js&"
export * from "./versionInformation.vue?vue&type=script&lang=js&"
import style0 from "./versionInformation.vue?vue&type=style&index=0&id=7a9bd08a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9bd08a",
  null
  
)

export default component.exports